import '../../styles/components.css';

export const WhatsAppButton = () => (
  <div className="whatsapp-button">
    <a href="https://wa.me/543574511196?text=Hola%20K-Ching%2C%20quiero%20consultar%20por%20un%20proyecto." target="_blank" rel="noreferrer" aria-label="Contactar a K-Ching por WhatsApp">
      <img src={require('../../images/whatsapp-logo.webp')} alt="" />
    </a>
  </div>
);
